export class RateLimiter {
    private lastCallTime = 0;
    private timer: number;

    constructor(private minimumTimeBetweenCalls: number) {}

    public callMeMaybe(func: () => void) {
        clearTimeout(this.timer);

        if (this.lastCallTime < Date.now() - this.minimumTimeBetweenCalls) {
            this.lastCallTime = Date.now();
            func();
        } else {
            this.timer = window.setTimeout(() => this.callMeMaybe(func), this.minimumTimeBetweenCalls);
        }
    }
}
